import NewTCManager from "../../features/marketingManager/NewTCManager"

const NewTCManagerPage = () => {
  return <NewTCManager />
}

export default NewTCManagerPage